export default __webpack_public_path__ + "static/media/ElectricityIsEverywhere_12.0269f853.png";